import {
  createContext,
  PropsWithChildren,
  use,
  useMemo,
  useState,
} from "react";

const SpatialViewerContext =
  createContext<ReturnType<typeof useProvider>>(null);

export const useSpatialViewer = () => use(SpatialViewerContext);

export const SpatialViewerProvider = (p: PropsWithChildren<{}>) => {
  const value = useProvider();
  return (
    <SpatialViewerContext value={value}>{p.children}</SpatialViewerContext>
  );
};

const useProvider = () => {
  const [position, setPosition] = useState({ x: 0, y: 0, w: 0, h: 0 });
  const [isHidden, setIsHidden] = useState(false);
  return useMemo(
    () => ({
      position,
      setPosition,
      isHidden,
      setIsHidden,
    }),
    [position, isHidden],
  );
};
